module.exports = __webpack_public_path__ + "img/text.a5b03cf3.png";